module.exports = __webpack_public_path__ + "img/domains-step-4.en.c759cfe5.png";